import ComicCard from "@/components/base/ComicCard";
import { allComics } from "@/mocks/comics";
import { Link } from "react-router-dom";

export default function FeaturedComics() {
  const featured = allComics.filter((c) => c.rating >= 9.5).slice(0, 3);

  return (
    <section className="py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              口碑爆棚的高分韩漫，不容错过
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="large" />
          ))}
        </div>
      </div>
    </section>
  );
}